export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGIN_USER = "LOGIN_USER";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";